import { Alert, Box, Container, Button, CircularProgress, Grid, Stack, TextField, Typography } from "@mui/material";
import cssVars from '../../styles/vars.module.scss'
import useTranslation from "../../hooks/useTranslation";
import NextLink from 'next/link';
import { useState } from "react";
import { useMutation } from "@apollo/client";
import { validateEmail } from "../../helpers/validation";
import { REQUEST_NEW_PASSWORD } from "../../graphql/authentication/mutations";
import CustomMetas from "../../components/custom-metas/customMetas";
import { useTheme } from "@mui/material";

const ForgotPassword = () => {
    const { t } = useTranslation()
    const [email, setEmail] = useState('')
    const [formCheck, setFormCheck] = useState(false)

    const [requestNewPassword, { data, loading, error }] = useMutation(REQUEST_NEW_PASSWORD)

    const handleSubmit = (e) => {
        e.preventDefault();
        setFormCheck(true)
        if (e.target.checkValidity() && validateEmail(email)) {
            requestNewPassword({
                variables: {
                    email
                },
                onError: () => { }
            })
        }

    }
    const theme = useTheme()

    return (
        <Container maxWidth="xl" sx={{ px: { xs: 0, sm: 0 } }} >
            <CustomMetas title="Reset password"
                description="Reset password"
                keywords="Reset password"
                page_type="product.item"
                noindex
            />
            <Box component="form" onSubmit={handleSubmit} autoComplete="off" >
                <Grid item container columns={150} justifyContent="center" sx={{ mt: { md: 5 }, mb: 21 }} >
                    <Grid item xs={150} md={75} lg={50} sx={{ border: { md: `1px solid ${cssVars.gray}` }, borderRadius: cssVars.radius, px: 4, py: 3, mb: 5 }} >
                        <Typography sx={{ fontWeight: 600, fontSize: "18px" }} variant="span">{t("Forgot your password")}</Typography>
                        <Grid container item columns={12} position="relative" >
                            <Grid item lg={12} sx={{ mt: 4 }} >
                                <Typography variant="body1" sx={{ fontWeight: 500, color: cssVars.black, fontSize: "16px" }} >
                                    {t("Enter your email address below and we will send you instructions to reset your password")}
                                </Typography>
                                {error ?
                                    <Stack sx={{ width: '100%', my: 2 }} >
                                        <Alert severity="error">{error.message}</Alert>
                                    </Stack>
                                    :
                                    null
                                }
                                {data ?
                                    <Stack sx={{ width: '100%', my: 2 }} >
                                        <Alert severity="success">{t("Message sent successfully")}</Alert>
                                    </Stack>
                                    :
                                    null
                                }
                            </Grid>
                            <Grid item xs={12} sx={{ mt: 4 }} >
                                <TextField
                                    label={t("Email")}
                                    placeholder="example@example.com"
                                    fullWidth
                                    value={email}
                                    className="custom-input"
                                    type="email"
                                    error={formCheck && !validateEmail(email)}
                                    onChange={(e) => { setEmail(e.target.value) }}
                                />
                            </Grid>

                            <Grid display={formCheck && !validateEmail(email) ? "block" : "none"} sx={{ fontSize: "14px", color: cssVars.red, top: "160px" }} >{t("Email is required")}</Grid>

                            <Grid item xs={12} >
                                <Button
                                    sx={{
                                        mt: 4,
                                        fontSize: "16px",
                                        py: "1.4rem !important",
                                        backgroundColor: `${!loading ? theme.palette.primary.main : cssVars.darkGray} ! important`,
                                        color: `${cssVars.white} ! important`,
                                        border: `1px solid ${!loading ? theme.palette.primary.main : cssVars.darkGray} ! important`,
                                        borderRadius: `${cssVars.radius} ! important`,
                                        ':hover': {
                                            bgcolor: `${!loading ? theme.palette.primary.dark : cssVars.darkGray} ! important `,
                                            borderColor: `${!loading ? theme.palette.primary.dark : cssVars.darkGray} ! important`,
                                            color: `${cssVars.white} ! important`
                                        },
                                        textTransform: 'unset'
                                    }}
                                    fullWidth
                                    type="submit"
                                    disabled={loading}
                                >
                                    {t("Submit")}
                                    {loading && <CircularProgress sx={{ ml: 1 }} style={{ width: "15px", height: "15px", color: cssVars.white }} />}
                                </Button>
                            </Grid>

                            <Grid item lg={12} display="flex" alignItems="center" justifyContent="center" sx={{ mt: 4 }}  >
                                <NextLink href={'/customer/login.html'} style={{ textDecoration: 'underLine', fontWeight: 500, fontSize: 14 }} >{t("Sign in instead")}</NextLink>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
}

export default ForgotPassword; 